import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！我们会将最新韩漫资讯发送到你的邮箱。');
      setEmail('');
      return;
    }

    const submitUrl = 'https://readdy.ai/api/form/d9osdhqftmtnfcfh0d70';

    try {
      const response = await fetch(submitUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email } as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = { code: 'OK' };
      }

      if (response.ok && parsed.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会将最新韩漫资讯发送到你的邮箱。');
        setEmail('');
      } else {
        const errorMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败，请稍后重试';
        if (errorMsg.includes('spam') || errorMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('订阅失败，请稍后重试');
        } else {
          setStatus('error');
          setMessage(errorMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-secondary-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-64 h-64 rounded-full bg-accent-500 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 rounded-full bg-primary-500 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-500/20 text-accent-400">
          <i className="ri-mail-send-line text-xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          订阅韩漫更新提醒
        </h2>
        <p className="text-secondary-300 text-sm mb-6">
          不错过任何一部好漫画！订阅后我们会将最新上架的韩漫和热门推荐第一时间发送给你。
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 max-w-md mx-auto" data-readdy-form>
          <input
            type="text"
            name="website_alt"
            autoComplete="off"
            tabIndex={-1}
            readOnly
            aria-hidden="true"
            style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, width: 0, pointerEvents: 'none' }}
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="输入你的邮箱地址"
            className="flex-1 px-5 py-3 rounded-full text-sm bg-background-50 text-foreground-900 placeholder-foreground-400 border border-secondary-300 focus:outline-none focus:ring-2 focus:ring-accent-400"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-bold rounded-full transition-all duration-300 whitespace-nowrap text-sm disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-accent-300 text-sm">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-red-400 text-sm">{message}</p>
        )}
      </div>
    </section>
  );
}